import { useLocation } from 'react-router';
import { notificationError } from '@nordvpn/teams.core/lib/atoms/Notification/tools';
import { LOGOUT as LOGOUT_PATH } from '@nordvpn/teams.core/lib/auth/constants';
import fetchErrorFromResponse, { ERROR_MESSAGES } from '@nordvpn/teams.core/lib/tools/fetchErrorFromResponse';
import { Loader } from '@nordvpn/teams.ui/lib/mui';
import { getUserToken } from 'pages/LoginOld/utils';
import { CHANGE_EMAIL_INVITATION_BASE_PATH } from 'routing/routes/myProfile/constants';
import { updatePermissions } from 'utils/permissions';
import { useAccount } from 'api/Account/queries';
import { IRequestErrorCode } from 'api/enums';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var Preloader = function Preloader(_ref) {
    var children = _ref.children;
    var _useLocation = useLocation(), pathname = _useLocation.pathname;
    var token = getUserToken();
    var isLogoutPage = pathname.includes(LOGOUT_PATH, 0);
    var isChangeEmailInvitationPage = pathname.includes(CHANGE_EMAIL_INVITATION_BASE_PATH, 0);
    var _useAccount = useAccount({
        enabled: !isChangeEmailInvitationPage && (token === null || token === void 0 ? void 0 : token.length) !== 0,
        onSuccess: function onSuccess(_ref2) {
            var _data$permissions;
            var data = _ref2.data;
            updatePermissions((_data$permissions = data === null || data === void 0 ? void 0 : data.permissions) !== null && _data$permissions !== void 0 ? _data$permissions : []);
        },
        onError: function onError(error) {
            var _error$response;
            var errorMessage = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.code) === IRequestErrorCode.SessionExpired ? ERROR_MESSAGES.SessionExpired : fetchErrorFromResponse(error.response);
            notificationError(errorMessage);
        }
    }), isLoading = _useAccount.isLoading;
    // If user on change email invitation page, children should be rendered without loading
    if (isChangeEmailInvitationPage) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    // If user is on logout page, children should be rendered in order to
    // initiate logout flow (remove tokens, redirect to login page).
    return isLoading && !isLogoutPage ? /*#__PURE__*/ _jsx(Loader, {
        "data-testid": "preloader-loader"
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
